import { IsNotEmpty, IsString } from 'class-validator';

export class RefreshTokenRequestDto {
    @IsNotEmpty({ message: 'Invalid request' })
    @IsString({ message: 'Invalid request' })
    refreshToken: string;
}
